import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Injector, Input, OnInit, SkipSelf } from '@angular/core';
import { ButtonComponent } from '@common/components/button/button.component';
import { pencil } from '@icons';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'button[climbDetailButton]',
    templateUrl: './detail-button.component.html',
    styleUrls: ['./detail-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailButtonComponent extends ButtonComponent implements OnInit {
    readonly icons = { pencil };

    @HostBinding('attr.title')
    @Input() title = 'Details';

    constructor(
        injector: Injector,
        elementRef: ElementRef,
        @SkipSelf() cdr: ChangeDetectorRef,
    ) {
        super(injector, elementRef, cdr);
    }

    ngOnInit(): void {
        super.ngOnInit();
        super.variant = 'ghost';
        super.size = 'sm';
        super.onlyIcon = true;
    }
}
